export const CANDIDATE_STAGES = [
  'Screening',
  'Interviewing',
  'Reference Checks',
  'Offer',
  'Hired',
  'Talent Pool',
  'Not selected',
] as const;

export type CandidateStage = typeof CANDIDATE_STAGES[number];

export interface FilterState {
  position: string;
  dominance: { min: number; max: number };
  extraversion: { min: number; max: number };
  patience: { min: number; max: number };
  formality: { min: number; max: number };
  objectivity: { min: number; max: number };
  status: string[];
  statusMode: 'include' | 'exclude';
}

export const DEFAULT_FILTER_STATE: FilterState = {
  position: 'all',
  dominance: { min: 0, max: 100 },
  extraversion: { min: 0, max: 100 },
  patience: { min: 0, max: 100 },
  formality: { min: 0, max: 100 },
  objectivity: { min: 0, max: 100 },
  status: [],
  statusMode: 'include',
};

export const hasActiveFilters = (filters: FilterState): boolean =>
  filters.position !== 'all' ||
  filters.dominance.min !== 0 || filters.dominance.max !== 100 ||
  filters.extraversion.min !== 0 || filters.extraversion.max !== 100 ||
  filters.patience.min !== 0 || filters.patience.max !== 100 ||
  filters.formality.min !== 0 || filters.formality.max !== 100 ||
  filters.objectivity.min !== 0 || filters.objectivity.max !== 100 ||
  filters.status.length > 0;
